import { QUERYSTRING_IFRAMEURL } from '../constants/queryString';
import { getQueryParameter } from './getQueryParameter';

const trailingSlashRegex = /\/$/;
const removeTrailingSlash = (url: string) => url.replace(trailingSlashRegex, '');

export const isCurrentLocation = (url: string | null | undefined): boolean => {
  if (!url) {
    return false;
  }

  const queryStringIndex = url.indexOf('?');
  const cleanUrl = removeTrailingSlash(queryStringIndex > -1 ? url.slice(0, queryStringIndex) : url);
  const cleanPathname = removeTrailingSlash(document.location.pathname.replace(trailingSlashRegex, ''));

  if (cleanPathname === cleanUrl) {
    const currentIframeUrl = getQueryParameter(QUERYSTRING_IFRAMEURL);
    const urlSearch = queryStringIndex > -1 ? url.slice(queryStringIndex) : undefined;
    const urlQueryParameters = new URLSearchParams(urlSearch);
    const urlIframeUrl = urlQueryParameters.get(QUERYSTRING_IFRAMEURL);

    return currentIframeUrl === urlIframeUrl;
  }

  return false;
};
